import { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const USER_RE_INVITE_GUEST_RESOURCE = "user" as const;
export const USER_RE_INVITE_GUEST_OPERATION = "re-invite-guest" as const;
export const USER_RE_INVITE_GUEST_API_PATH =
  `/v1/${USER_RE_INVITE_GUEST_RESOURCE}/${USER_RE_INVITE_GUEST_OPERATION}/{uuid}` as const;

export type MutationResponse =
  paths[typeof USER_RE_INVITE_GUEST_API_PATH]["post"]["responses"][201]["content"]["application/json"];

export const useUserReInviteGuestMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<MutationResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.post<MutationResponse>(
        `/v1/${USER_RE_INVITE_GUEST_RESOURCE}/${USER_RE_INVITE_GUEST_OPERATION}/${uuid}`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [USER_RE_INVITE_GUEST_RESOURCE],
      });
    },
  });
};
